var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('router-view'),(_vm.$route.name === 'home' || _vm.$route.name === 'home.invited')?_c('div',{staticClass:"privacy"},[_c('router-link',{attrs:{"to":"privacy"}},[_vm._v("Privacy")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }